<template>
  <div
    v-if="
      (Object.keys(order_detail).length === 0 &&
        order_detail.constructor === Object) ||
      fetching_data == true
    "
  >
    <v-toolbar color="white" dense flat>
      <v-btn
        icon
        @click="backToList()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <v-progress-circular
        :size="30"
        :width="5"
        color="primary"
        indeterminate
        class="ma-3"
      ></v-progress-circular>
      Loading...
      <v-spacer />
    </v-toolbar>
  </div>
  <div v-else>
    <v-toolbar dense flat dark>
      <v-btn
        icon
        @click="backToList()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <v-toolbar-title
        >Detail messenger order #{{ order_detail.order_code }}</v-toolbar-title
      >
      <v-spacer />
      <v-btn @click="dialogToggle" dark color="primary">
        <v-icon color="black">chat_bubble</v-icon>
      </v-btn>
      <v-btn
        dark
        color="red"
        @click="toCancelOrder()"
        :loading="canceling_order"
        :disabled="
          canceling_order ||
          (order_status_id == 6 &&
            $store.state.permission.order.edit_view != 3) ||
          (order_status_id == 7 &&
            $store.state.permission.order.edit_view != 3) ||
          (order_detail.order_status == 7 &&
            $store.state.permission.order.edit_view != 3) ||
          isEditOrder ||
          $route.name == 'OrderDetailMessenger'
        "
        >ยกเลิกออเดอร์</v-btn
      >
    </v-toolbar>

    <v-card class="mb-3">
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-card-text>
            <strong style="font-size: 18px">Order Information</strong>
            <!-- <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-text-field
                  :disabled="order_status_id == 6 || order_status_id == 7"
                  v-model="order_detail.order_code"
                  readonly
                  hide-details
                  label="Order code"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 class="ml-2">
                <v-text-field
                  :disabled="order_status_id == 6 || order_status_id == 7"
                  v-model="order_detail.order_amount_point"
                  readonly
                  hide-details
                  label="Position amount"
                ></v-text-field>
              </v-flex>
            </v-layout>-->
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <div
                  class="text-xs-left"
                  v-if="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    isEditOrder
                  "
                >
                  <label class="field-disable-title">Order coming date</label>
                  <br />
                  <div class="field-disable-data">
                    {{ order_detail.order_time_start.substring(0, 10) }}
                  </div>
                </div>
                <div class="text-xs-left" v-else>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="start_date_menu"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    class="mt-1"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="start_date"
                      label="Order start date: "
                      readonly
                      hide-details
                    ></v-text-field>
                    <v-date-picker
                      :min="moment().format('YYYY-MM-DD')"
                      v-model="start_date"
                      color="#333"
                      no-title
                      @input="start_date_menu = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-flex>
              <v-flex xs6 class="ml-2 text-xs-left">
                <div
                  class="text-xs-left"
                  v-if="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    isEditOrder
                  "
                >
                  <label class="field-disable-title">Order start time</label>
                  <br />
                  <div class="field-disable-data">
                    {{ order_detail.order_time_start.substring(11, 16) }}
                  </div>
                </div>
                <div
                  class="text-xs-left"
                  v-else
                  style="position: relative; border-bottom: 1px solid #757575"
                >
                  <span style="font-size: 12px; color: grey"
                    >Order start time</span
                  >
                  <vue-timepicker
                    hide-clear-button
                    format="HH:mm"
                    v-model="start_time"
                    style="width: 262px"
                  >
                  </vue-timepicker>
                </div>
              </v-flex>
            </v-layout>
            <!-- <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-text-field
                  v-if="order_status_id == 6 || order_status_id == 7"
                  v-model="start_date"
                  label="Transfer date"
                  readonly
                  hide-details
                ></v-text-field>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu2"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  v-if="start_date != null && order_status_id != 6 && order_status_id != 7"
                >
                  <v-text-field
                    slot="activator"
                    v-model="start_date"
                    label="Transfer date"
                    readonly
                    hide-details
                  ></v-text-field>
                  <v-date-picker v-model="start_date" color="#333" no-title @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                xs6
                class="ml-2 text-xs-left"
                style="position:relative;border-bottom:1px solid #757575"
              >
                <span class="title-after-input-data">Transfer time</span>
                <v-text-field
                  readonly
                  :value="order_detail.order_time_end.substring(11,16)"
                  hide-details
                  v-if="order_status_id == 6 || order_status_id == 7"
                ></v-text-field>
                <vue-timepicker
                  v-if="order_status_id != 6 && order_status_id != 7  && Object.keys(start_time).length != 0 && start_time.constructor === Object"
                  format="HH:mm"
                  class="forn-timepicker"
                  v-model="start_time"
                  style="top:17px;position:absolute;left:-7px;width:262px;"
                ></vue-timepicker>
              </v-flex>
            </v-layout>-->
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-text-field
                  v-if="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    isEditOrder
                  "
                  v-model="end_date"
                  :disabled="isEditOrder"
                  label="Transfer date"
                  readonly
                  hide-details
                >
                </v-text-field>
                <!-- <div class="text-xs-left" v-if="order_status_id == 6 || order_status_id == 7">
                  <label class="field-disable-title">Transfer date</label>
                  <br>
                  <div class="field-disable-data">{{end_date}}sss</div>
                </div>-->
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu2"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  v-if="
                    end_date != null &&
                    order_status_id != 6 &&
                    order_status_id != 7 &&
                    !isEditOrder
                  "
                >
                  <v-text-field
                    slot="activator"
                    v-model="end_date"
                    label="Transfer date"
                    readonly
                    hide-details
                  >
                  </v-text-field>
                  <v-date-picker
                    :min="moment().format('YYYY-MM-DD')"
                    v-model="end_date"
                    color="#333"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                xs6
                class="ml-2 text-xs-left"
                style="position: relative; border-bottom: 1px solid #757575"
              >
                <span class="title-after-input-data">Transfer time</span>
                <v-text-field
                  readonly
                  :value="order_detail.order_time_end.substring(11, 16)"
                  hide-details
                  :disabled="isEditOrder"
                  v-if="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    isEditOrder
                  "
                ></v-text-field>
                <vue-timepicker
                  v-if="
                    order_status_id != 6 &&
                    order_status_id != 7 &&
                    Object.keys(end_time).length != 0 &&
                    end_time.constructor === Object &&
                    !isEditOrder
                  "
                  format="HH:mm"
                  class="forn-timepicker"
                  v-model="end_time"
                  style="
                    top: 17px;
                    position: absolute;
                    left: -7px;
                    width: 262px;
                  "
                ></vue-timepicker>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-select
                  :class="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3)
                      ? 'hidden-disable'
                      : ''
                  "
                  :disabled="
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    isEditOrder
                  "
                  :items="status"
                  item-text="name"
                  item-value="value"
                  v-model="order_detail.order_status"
                  hide-details
                  label="Status"
                ></v-select>
              </v-flex>
              <v-flex xs6 class="ml-2">
                <v-select
                  class="hidden-disable"
                  :items="vehicle_list"
                  :disabled="true"
                  item-text="vehicle_title_th"
                  item-value="vehicle_id"
                  :loading="vehicle_list.length == 0 ? 'yellow' : false"
                  v-model="order_detail.order_vehicle_type"
                  hide-details
                  label="Vehicle type"
                ></v-select>
                <!-- <div class="text-xs-left">
                  <label class="field-disable-title">Vehicle type</label>
                  <br>
                  <div class="field-disable-data">{{order_detail.order_vehicle_type}} {{vehicle_list[0].vehicle_title_th}}</div>
                </div>-->
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <!-- "order_status_id == 6 || order_status_id == 7" -->
                <!-- <v-select
                  disabled
                  :items="pay"
                  item-text="name"
                  item-value="value"
                  v-model="order_detail.order_payment_type"
                  hide-details
                  label="COD"
                ></v-select>-->
                <div class="text-xs-left">
                  <label class="field-disable-title">COD</label>
                  <br />
                  <div class="field-disable-data">
                    {{
                      order_detail.order_payment_type == 1
                        ? "Cash"
                        : order_detail.order_payment_type == 2
                        ? "Credit card"
                        : order_detail.order_payment_type == 3
                        ? "PromptPay"
                        : order_detail.order_payment_type == 4
                        ? "Cryptocurrency"
                        : order_detail.order_payment_type == 5
                        ? "AR"
                        : ""
                    }}
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="ml-2">
                <!-- <v-select
                  disabled
                  :items="pay_status"
                  item-text="name"
                  item-value="value"
                  v-model="order_detail.order_is_paymented"
                  hide-details
                  label="Pay status"
                ></v-select>-->
                <div class="text-xs-left">
                  <label class="field-disable-title">Pay status</label>
                  <br />
                  <div class="field-disable-data">
                    {{
                      order_detail.order_is_paymented == 1
                        ? "Not pay"
                        : order_detail.order_is_paymented == 2
                        ? "Paid"
                        : ""
                    }}
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <v-select
              class="hidden-disable-addon"
              :disabled="
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder
              "
              :loading="add_on_list.length == 0 ? 'yellow' : false"
              v-model="order_detail.order_addon"
              :items="add_on_list"
              item-text="addon_title_th"
              item-value="addon_type_id"
              attach
              chips
              color="black"
              label="Add on"
              multiple
              hide-details
            ></v-select>
            <v-textarea
              v-if="
                order_status_id != 6 && order_status_id != 7 && !isEditOrder
              "
              :disabled="
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder
              "
              v-model="order_detail.order_transfer_note"
              hide-details
              rows="2"
              label="Note to rider :"
            ></v-textarea>
            <div
              class="text-xs-left mt-2"
              v-if="
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder
              "
            >
              <label class="field-disable-title">Note to rider :</label>
              <br />
              <div class="field-disable-data">
                {{ order_detail.order_transfer_note }}
              </div>
            </div>
            <v-textarea
              v-model="order_detail.order_note"
              hide-details
              :disabled="isEditOrder"
              rows="2"
              label="Admin note :"
            ></v-textarea>
            <!-- <div class="text-xs-left mt-3" v-if="order_status_id == 7">
              <label class="field-disable-title">Admin note :</label>
              <br>
              <div class="field-disable-data">{{order_detail.order_note}}</div>
            </div>-->
          </v-card-text>
        </v-flex>
        <v-flex xs12 sm6>
          <v-card-text>
            <div class="pb-4">
              <strong style="font-size: 18px">Customer Information</strong>
              <v-card flat class="text-xs-left mt-2" color="#EEEEEE">
                <v-card-text style="font-size: 15px">
                  <span>
                    Name :
                    {{
                      order_detail.order_customer_full_name ||
                      order_detail.order_business_full_name
                    }}
                    <span style="color: #ababab">|</span>
                    {{ order_detail.order_customer_country_tel || ""
                    }}{{
                      order_detail.order_customer_tel ||
                      "0" + order_detail.order_business_tel
                    }}
                    <span style="color: #ababab">|</span>
                    {{
                      order_detail.order_customer_email ||
                      order_detail.order_business_email
                    }}
                  </span>
                </v-card-text>
              </v-card>

              <div class="mt-3">
                <div style="font-size: 18px; font-weight: bold">
                  Destination Information ({{ order_detail.order_amount_point }}
                  position)
                </div>
                <v-btn
                  small
                  color="primary"
                  class="black--text"
                  @click="expand = !expand"
                  >Show all detail</v-btn
                >
                <div
                  v-for="(place_info, place_index) in order_detail.order_point"
                  :key="place_info.order_point_id"
                >
                  <v-list class="pb-0">
                    <v-card>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <v-icon>place</v-icon>
                            {{ place_index + 1 }} :
                            {{ place_info.order_point_address }}
                          </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action
                          style="position: absolute; right: 40px"
                        >
                          <v-tooltip top>
                            <v-icon
                              slot="activator"
                              :color="
                                place_info.order_point_status == 1
                                  ? 'green'
                                  : 'grey '
                              "
                              >{{
                                place_info.order_point_status == 1
                                  ? "check_circle"
                                  : "schedule"
                              }}</v-icon
                            >
                            <span>Status</span>
                          </v-tooltip>
                        </v-list-tile-action>
                        <v-list-tile-action>
                          <v-tooltip top>
                            <v-icon
                              slot="activator"
                              :color="
                                place_info.order_point_status == 1
                                  ? 'green'
                                  : 'grey '
                              "
                              @click="viewIMG(place_info)"
                              >image</v-icon
                            >
                            <span>View image</span>
                          </v-tooltip>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-card>
                  </v-list>
                  <imageDialog
                    :place_name="place_name"
                    :view_img_position="view_img_position"
                    :dialog="imageDialog"
                    @dialog="imageDialog = $event"
                  />
                  <v-scale-transition>
                    <v-card v-show="expand">
                      <v-card-text class="px-5 pt-1 grey lighten-3">
                        <v-layout row>
                          <v-flex xs12 class="mr-2">
                            <v-text-field
                              :disabled="
                                (order_status_id == 6 &&
                                  $store.state.permission.order.edit_view !=
                                    3) ||
                                (order_status_id == 7 &&
                                  $store.state.permission.order.edit_view !=
                                    3) ||
                                isEditOrder ||
                                $route.name == 'OrderDetailMessenger'
                              "
                              v-model="place_info.order_point_to"
                              hide-details
                              label="Full name"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs12 class="mr-2">
                            <v-text-field
                              hide-details
                              :disabled="
                                (order_status_id == 6 &&
                                  $store.state.permission.order.edit_view !=
                                    3) ||
                                (order_status_id == 7 &&
                                  $store.state.permission.order.edit_view !=
                                    3) ||
                                isEditOrder ||
                                $route.name == 'OrderDetailMessenger'
                              "
                              v-model="place_info.order_point_list_tel"
                              label="Tel"
                              mask="###-###-####"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                        <!-- <v-text-field
                          hide-details
                          :disabled="order_status_id == 6 || order_status_id == 7"
                          v-model="place_info.order_point_email"
                          label="E-mail "
                        ></v-text-field>-->
                        <v-textarea
                          :disabled="
                            (order_status_id == 6 &&
                              $store.state.permission.order.edit_view != 3) ||
                            (order_status_id == 7 &&
                              $store.state.permission.order.edit_view != 3) ||
                            isEditOrder ||
                            $route.name == 'OrderDetailMessenger'
                          "
                          name="address"
                          v-model="place_info.order_point_remark"
                          hide-details
                          label="Note : "
                          value
                          rows="2"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-scale-transition>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-flex>
      </v-layout>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-layout column>
          <v-flex>
            <v-btn
              block
              round
              color="primary"
              class="black--text"
              :disabled="update_btn || update_loading == 1 || isEditOrder"
              @click="updateData()"
              >update</v-btn
            >
          </v-flex>
          <v-flex>
            <div transition="fade">
              <v-icon color="green" v-if="update_loading == 2">check</v-icon>
              <v-icon color="red" v-if="update_loading == 3">close</v-icon>
              <v-progress-circular
                :width="3"
                :size="15"
                indeterminate
                color="grey"
                v-if="update_loading == 1"
              >
              </v-progress-circular>
              {{
                update_loading == 1
                  ? "Updating"
                  : update_loading == 2
                  ? "Update successfully"
                  : update_loading == 3
                  ? "Cant update"
                  : null
              }}
            </div>
          </v-flex>
        </v-layout>
        <v-spacer />
      </v-card-actions>
      <v-divider />
      <div style="font-size: 18px; font-weight: bold" class="pt-3">
        Map destination
      </div>

      <v-card-text style="display: flex; justify-content: center; width: 100%">
        <v-card height="auto" width="100%" color="white">
          <GoogleMap
            :multiplePosition="positionLating()"
            :height="350"
            :zoom="15"
            :mapType="'multipleFixed'"
            :change="change"
          ></GoogleMap>
        </v-card>
      </v-card-text>
    </v-card>

    <v-card class="mt-3">
      <div style="font-size: 18px; font-weight: bold" class="pt-3">
        Price Information
      </div>
      <v-layout row wrap align-end justify-center>
        <v-flex xs12 sm7>
          <v-card-text>
            <!-- <strong style="font-size: 18px;">Price Information</strong> -->
            <v-layout row justify-end align-end>
              <v-flex>
                <table
                  style="font-size: 16px; padding: 0 0 10px 20px"
                  width="90%"
                >
                  <tr>
                    <td
                      class="text-xs-left"
                      style="color: orange; font-weight: bold"
                    >
                      ระยะทางรวม
                    </td>
                    <td
                      class="text-xs-right"
                      style="color: orange; font-weight: bold"
                    >
                      {{
                        order_detail.order_point.reduce(
                          (a, b) =>
                            parseFloat(a.order_point_distance) ||
                            0 + parseFloat(b.order_point_distance) ||
                            0,
                          0
                        )
                      }}
                      km
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">Transportation :</td>
                    <td class="text-xs-right">
                      {{ order_detail.order_transfer_price }} THB
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">Add on :</td>
                    <td class="text-xs-right">
                      {{ order_detail.order_total_addon_price }} THB
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">Extra point :</td>
                    <td class="text-xs-right">
                      {{ order_detail.order_store_extra_price }} THB
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left" style="color: red">Discount :</td>
                    <td class="text-xs-right" style="color: red">
                      {{ order_detail.order_total_discount_price }} THB
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="text-xs-left"
                      style="color: green; font-weight: bold"
                    >
                      Total price :
                    </td>
                    <td
                      class="text-xs-right"
                      style="color: green; font-weight: bold"
                    >
                      {{ order_detail.order_net_price }} THB
                    </td>
                  </tr>
                </table>

                <!-- <v-divider/>
                <table style="padding:0 16px;" width="100%">
                  <tr>
                    <td class="text-xs-right green--text">
                      <strong>{{ order_detail.order_net_price }} ฿</strong>
                    </td>
                  </tr>
                </table>-->
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-flex>

        <v-flex xs9 sm6>
          <v-layout row wrap>
            <v-flex xs9>
              <v-text-field
                hide-details
                class="ml-3"
                solo
                v-model="use_promo_code"
                label="Promotion code"
                :disabled="
                  order_status_id != 1 ||
                  order_detail.order_resend_order.length != 0 ||
                  isEditOrder ||
                  $route.name == 'OrderDetailMessenger'
                "
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-btn
                @click="usePromotion()"
                style="margin-bottom: 39px"
                :loading="using_promo_code"
                :disabled="
                  order_status_id != 1 ||
                  order_detail.order_resend_order.length != 0 ||
                  isEditOrder ||
                  $route.name == 'OrderDetailMessenger'
                "
                >add</v-btn
              >
            </v-flex>
          </v-layout>
          <v-card class="mb-3">
            <v-layout row wrap align-center>
              <v-flex xs9>
                <div
                  style="
                    color: grey;
                    padding: 10px 0 10px 20px;
                    text-align: left;
                    font-size: 16px;
                  "
                  v-if="
                    order_detail.order_discount == null &&
                    order_detail.order_discount_code != null
                  "
                >
                  Recent promotion : {{ order_detail.order_discount_code }}
                </div>
                <div
                  style="
                    padding: 10px 0 10px 20px;
                    text-align: left;
                    font-size: 16px;
                  "
                  v-if="
                    order_detail.order_discount != null &&
                    order_detail.order_discount_code != null
                  "
                >
                  <div>
                    Promotion code :
                    <span style="font-weight: bold">{{
                      order_detail.order_discount_code
                    }}</span>
                  </div>
                  <div>
                    Promotion name :
                    <span style="color: grey"
                      >{{ order_detail.order_discount.promotion_name_th }} (
                      {{ order_detail.order_discount.promotion_detail }} )</span
                    >
                  </div>
                </div>
              </v-flex>
              <v-flex xs3>
                <v-btn
                  @click="deletePromotion()"
                  :disabled="
                    deletingPromotion ||
                    isEditOrder ||
                    (order_status_id == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status_id == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_detail.order_status == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    $route.name == 'OrderDetailMessenger'
                  "
                  :loading="deletingPromotion"
                  v-if="
                    order_detail.order_discount != null &&
                    order_detail.order_discount_code != null
                  "
                  >remove</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card>
          <!-- <div
            style="color:grey;padding:10px 0 10px 20px;text-align:left;font-size:16px;"
            v-if="order_detail.order_discount == null && order_detail.order_discount_code != null"
          >Recent promotion : {{order_detail.order_discount_code }}</div>
          <div
            style="color:green;padding:10px 0 10px 20px;text-align:left;font-size:16px;"
            v-if="order_detail.order_discount != null && order_detail.order_discount_code != null"
          >
            <div>Promotion code : {{order_detail.order_discount_code }}</div>

            <div>Promotion name : {{order_detail.order_discount.promotion_name_th }} - {{order_detail.order_discount.promotion_detail}}</div>
          </div>-->
        </v-flex>
      </v-layout>
    </v-card>
    <chatlog
      :openDialogChat="openDialogChat"
      :statusBtn="statusBtn"
      :order_detail_message="order_detail"
      :provinceData="provinceData"
      @toggleDialogChat="toggleDialogChat"
    />
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="mt-3">
          <v-card-text>
            <rider-information
              @cloneOrder="cloneOrder()"
              :order_detail="order_detail"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <orderLog class="mt-3" :order_detail="order_detail" />
    <v-dialog v-model="cancelDialog" persistent max-width="300px">
      <v-card
        ><v-card-title style="background-color: #212121"
          ><h3 style="color: white">Why do you want to cancel ?</h3>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              cancelDialog = false;
              cancelRemark = '';
            "
          >
            <v-icon color="white">close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formCancel">
            <v-text-field
              label="Reason"
              v-model="cancelRemark"
              :rules="[
                (v) => !!v || 'Required',
                (v) =>
                  v.replace(/\ /g, '').replace(/\-/g, '') != '' ||
                  'No symbol only',
              ]"
            ></v-text-field></v-form
        ></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" style="color: #212121" @click="cancelOrder()"
            >submit</v-btn
          ></v-card-actions
        ></v-card
      >
    </v-dialog>
  </div>
</template>

<script>
import chatlog from "../OrderOnline/OrderDetail/Chat";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import imageDialog from "./ImageDialog";
import riderInformation from "./OrderDetail/RiderInformation.vue";
import orderLog from "./OrderDetail/OrderLog.vue";
import { mapState, mapGetters } from "vuex";
export default {
  props: ["order_id"],
  components: {
    chatlog,
    VueTimepicker,
    imageDialog,
    riderInformation,
    orderLog,
  },
  data() {
    return {
      deletingPromotion: false,
      statusBtn: "",
      openDialogChat: false,
      change: 0,
      start_date_menu: false,
      place_name: null,
      fetching_data: false,
      original_data: {},
      using_promo_code: false,
      use_promo_code: "",
      canceling_order: false,
      update_loading: 0,
      original_end_time: {},
      original_end_date: null,
      end_date: null,
      end_time: {},
      original_start_time: {},
      original_start_date: null,
      start_date: null,
      start_time: {},
      view_img_position: null,
      form_rider: {},
      changing_rider: false,
      change_rider: [],
      headers: [
        { text: "No.", align: "center", sortable: false, value: "num" },
        { text: "Time", value: "time", sortable: false, align: "center" },
        { text: "User", value: "user", sortable: false, align: "center" },
      ],
      log: [
        {
          num: "1",
          time: "11:59",
          user: "nynk",
        },
        {
          num: "2",
          time: "13:00",
          user: "piew",
        },
      ],
      expand: false,
      imageDialog: false,
      place: 5,
      add_on_value: ["ไป-กลับ", "กล่องใส่อาหาร"],
      date: new Date().toISOString().substr(0, 10),
      menu2: false,
      status: [
        { name: "Order made", value: 1 },
        { name: "In queue", value: 2 },
        { name: "On the way", value: 5 },
        { name: "Completed", value: 6 },
      ],
      pay: [
        { name: "Cash", value: 1 },
        { name: "Credit card", value: 2 },
      ],
      pay_status: [
        { name: "Paid", value: 2 },
        { name: "Not pay", value: 1 },
      ],
      cancelRemark: "",
      cancelDialog: false,
    };
  },
  computed: {
    ...mapState({
      order_status_id: (state) => state.fetchOrderListBack.order_status_id,
      order_detail: (state) => state.fetchOrderDetailBack.order_detail_me,
      vehicle_list: (state) => state.fetchOrderDetailBack.vehicle_list,
      add_on_list: (state) => state.fetchOrderDetailBack.add_on_list_me,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
    update_btn() {
      this.update_btn_disable = this.unSavedData();
      return this.update_btn_disable;
    },
  },
  methods: {
    async deletePromotion() {
      this.deletingPromotion = true;
      let check = await this.$store.dispatch(
        "fetchOrderDetailBack/deletePromotion",
        this.order_detail
      );
      if (check != false) {
        this.$emit("cloneOrder");
      }
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status_id
      );
      this.deletingPromotion = false;
    },
    toggleDialogChat(value) {
      this.openDialogChat = !value;
      // this.statusBtn = "";
    },
    dialogToggle() {
      this.openDialogChat = !this.openDialogChat;
      this.statusBtn = "oder_mess_detail";
    },
    positionLating() {
      let response = [];
      for (let val of this.order_detail.order_point) {
        let position_data = {
          latitude: val.order_point_lat,
          longitude: val.order_point_long,
        };
        response.push(position_data);
      }
      return response;
    },
    cloneOrder() {
      this.original_data = JSON.parse(JSON.stringify(this.order_detail)); // forUnsavedData
    },
    unSavedData() {
      if (
        (JSON.stringify(this.original_data) !=
          JSON.stringify(this.order_detail) ||
          JSON.stringify(this.end_date) !=
            JSON.stringify(this.original_end_date) ||
          JSON.stringify(this.end_time) !=
            JSON.stringify(this.original_end_time) ||
          JSON.stringify(this.start_date) !=
            JSON.stringify(this.original_start_date) ||
          JSON.stringify(this.start_time) !=
            JSON.stringify(this.original_start_time)) &&
        this.fetching_data == false
      ) {
        return false;
      } else {
        return true;
      }
    },
    async usePromotion() {
      this.using_promo_code = true;
      let check = await this.$store.dispatch(
        "fetchOrderDetailBack/usePromotionME",
        {
          order_id: this.order_detail.order_id,
          use_promo_code: this.use_promo_code,
        }
      );
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status_id
      );
      if (check.promotion_status == false) {
        alert(check.data["name_" + this.$i18n.locale]);
      }

      this.using_promo_code = false;
    },
    toCancelOrder() {
      let isUnsavedData = !this.unSavedData();
      if (isUnsavedData == true) {
        alert("ข้อมูลมีการเปลี่ยนแปลง กรุณาอัพเดทก่อน");
      } else {
        this.cancelDialog = true;
        this.cancelRemark = "";
      }
    },
    async cancelOrder() {
      if (!this.$refs.formCancel.validate()) return;
      this.cancelDialog = false;
      this.canceling_order = true;
      let form = {
        order_id: this.order_detail.order_id,
        order_note:
          this.order_detail.order_note +
          " เหตุผลที่ยกเลิก: " +
          this.cancelRemark,
      };
      let check = await this.$store.dispatch(
        "fetchOrderListBack/cancelOrder",
        form
      );
      this.canceling_order = false;
      if (check == 2) {
        this.backToList();
      }
    },
    async updateData() {
      this.order_detail.order_time_start =
        this.start_date +
        "T" +
        this.start_time.HH +
        ":" +
        this.start_time.mm +
        ":00";
      this.order_detail.order_time_end =
        this.end_date + "T" + this.end_time.HH + ":" + this.end_time.mm + ":00";
      this.update_loading = 1;
      if (this.order_detail.order_status == 6) {
        this.order_detail.order_is_paymented = 2;
      } else {
        this.order_detail.order_is_paymented = 1;
      }
      this.update_loading = await this.$store.dispatch(
        "fetchOrderDetailBack/updateDataME",
        this.order_detail
      );
      if (this.update_loading == 2) {
        this.original_data = JSON.parse(JSON.stringify(this.order_detail));
        this.takeTime();
      }
      if (this.update_loading == 2 && this.order_detail.order_status == 6) {
        this.backToList();
      }
    },
    viewIMG(item) {
      this.place_name = item.order_point_address;
      this.view_img_position = item.order_point_submit_photo;
      this.imageDialog = true;
    },
    backToList() {
      if (
        this.$route.params.orderid &&
        this.$route.name == "OrderDetailMessenger"
      ) {
        this.$router.push({
          path:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/report/order_report",
        });
      } else {
        let isUnsavedData = !this.unSavedData();
        if (isUnsavedData == true) {
          confirm("คุณต้องการละทิ้งการเปลี่ยนแปลงหรือไม่ ? ") &&
            this.$emit("backListTable", "orderListTable");
        } else {
          this.$emit("backListTable", "orderListTable");
          this.$emit("setPagename", true);
        }
      }
    },
    async changeRider() {
      this.changing_rider = true;
      this.change_rider = await this.$store.dispatch(
        "fetchOrderDetailBack/getDataRider"
      );
      this.changing_rider = false;
    },
    takeTime() {
      if (this.order_detail.order_time_end != null) {
        this.end_date = this.order_detail.order_time_end.substring(0, 10);
        this.end_time = {
          HH: this.order_detail.order_time_end.substring(11, 13),
          mm: this.order_detail.order_time_end.substring(14, 16),
        };
      }
      this.original_end_date = JSON.parse(JSON.stringify(this.end_date));
      this.original_end_time = JSON.parse(JSON.stringify(this.end_time));

      if (this.order_detail.order_time_start) {
        this.start_date = this.order_detail.order_time_start.substring(0, 10);
        this.start_time = {
          HH: this.order_detail.order_time_start.substring(11, 13),
          mm: this.order_detail.order_time_start.substring(14, 16),
        };
      }
      this.original_start_date = JSON.parse(JSON.stringify(this.start_date));
      this.original_start_time = JSON.parse(JSON.stringify(this.start_time));
    },
    async fetchData() {
      this.fetching_data = true;
      await this.$store.dispatch(
        "fetchOrderDetailBack/getOrderDetailME",
        this.order_id
      );
      this.$store.dispatch("fetchOrderDetailBack/getVehicleList");
      if (this.order_detail.order_vehicle_type != undefined) {
        this.$store.dispatch(
          "fetchOrderDetailBack/getAddonME",
          this.order_detail.order_vehicle_type
        );
      }
      this.takeTime();
      this.fetching_data = false;
    },
  },
  async created() {
    if (
      this.$route.params.orderid &&
      this.$route.name == "OrderDetailMessenger"
    ) {
      this.$store.commit("fetchOrderListBack/setOrderStatusID", 6);
    }
    await this.fetchData();
    this.original_data = JSON.parse(JSON.stringify(this.order_detail)); // forUnsavedData
  },
};
</script>

<style scoped>
.test {
  background-color: aqua;
}

.field-disable-title {
  color: #9e9e9e;
  font-size: 12px;
}

.field-disable-data {
  color: #9e9e9e;
  font-size: 16px;
}

/* .time-picker input.display-time {
  border: none;
  background-color:pink;
} */
.forn-timepicker {
  border: none;
  font-size: 15px;
  padding: none;
}

.title-order-info-startend {
  font-size: 15px;
  color: grey;
  top: 5px;
  text-align: left;
  margin-top: 1rem;
}

.order-info-startend {
  font-size: 15px;
  /* color: grey; */
  border: 1px solid #d6d6d6;
  padding: 5px 10px;
  margin: 5px 0;
  border-radius: 5px;
  word-wrap: break-word;
  max-height: 92px;
  overflow: auto;
  text-align: left;
}

.title-after-input-data {
  font-size: 12px;
  color: grey;
  top: 5px;
  position: absolute;
}

.hidden-disable {
  overflow: visible;
  padding: 0;
  border: none;
  text-align: center;
  margin-top: 24px;
}

.hidden-disable:after {
  content: ".";
  color: white;
  width: 100%;
  position: absolute;
  top: 29px;
  font-size: 5px;
  background: white;
}

.hidden-disable-addon {
  overflow: visible;
  padding: 0;
  border: none;
  text-align: center;
  margin-top: 18px;
}

.hidden-disable-addon:after {
  content: ".";
  color: white;
  width: 100%;
  position: absolute;
  bottom: -5px;
  font-size: 5px;
  background: white;
}
</style>
